// we have to use this as-is
function sharp(...args) {
  if (!sharp.__module) {
    sharp.__module = __non_webpack_require__('sharp');
  }
  return sharp.__module(...args)
}

import {SetBinaryContent} from 'rlink-repos/commands';
import formattedImgPath from 'rlink-repos/formattedImgPath';


let instanceCache = new Map();
export async function processImages(command, repo, instanceFetchFn) {
  if (!command.constructor.isBinaryContentCommand) return [];

  if (!instanceCache.has(repo)) {
    instanceCache.set(repo, await instanceFetchFn());
  }

  let instances = instanceCache.get(repo);
  let contentPath = command.contentPath;
  let results = new Map();
  for (let instance of instances) {
    if (typeof instance.imageFormats === 'function') {
      for (let {src, formats, widths, heights} of instance.imageFormats()) {
        if(src === contentPath) {
          // key each format request so we don't have
          // duplicate requests when more than one instance
          // refers to the same image
          let key = `${command}${repo}${src}${widths}${heights}${JSON.stringify(formats)}`;
          // console.log("add key", key)
          results.set(key, processImageFormat(command, repo, {src, formats, widths, heights}));
        }
      }
    }
  }
  return Promise.all(results.values()).then(allResults => [].concat(...allResults));
}

export function processImageFormat(command, repo, format) {
  if (format.formats.length === 0
      || (format.widths.length === 0
        && format.heights.length === 0)) {
    throw new Error(`Invalid format spec: ${JSON.stringify(format)}`)
  }
  let results = [];
  for (let ftype of (format.formats
      || [{contentType: "image/jpeg", fileExt: "jpg"}])) {
    for ( let width of (format.widths || []) ) {
      results.push(formatImage(command, repo, {width}, ftype));
    }
    for (let height of (format.heights || [])) {
      results.push(formatImage(command, repo, {height}, ftype));
    }
  }
  return Promise.all(results);
}

function resize(src, dim) {
  return sharp(src)
    .resize(dim.width, dim.height ,{ withoutEnlargement: true });
}

var CODECS = {
  webp(src, dim) {
    return resize(src, dim).webp().toBuffer();
  },
  jpeg(src, dim) {
    return resize(src, dim).jpeg().toBuffer();
  },
  png(src, dim) {
    return resize(src, dim).png().toBuffer();
  }
}

CODECS.jpg = CODECS.jpeg;


export async function formatImage(command, repo, dim, ftype) {
  // console.log('processing img cmd', command, dim, ftype)
  if (command.isDeleteCommand) {
    return new command.constructor({
      contentPath: formattedImgPath(
        command.contentPath, dim, ftype.fileExt),
      contentClassName: 'BinaryContent'
    });
  } else {
    //must be set or create
    if (! (ftype.fileExt in CODECS) ) {
      throw new Error(`No codec available for fileExt: ${ftype.fileExt}`);
    }
    let commandClass = command.constructor;
    // sometimes we re-index images because something upstream has
    // invalidated - so we shouldn't conflict if our output already
    // exists:
    if (commandClass.name === 'CreateBinaryContent') {
      commandClass = SetBinaryContent;
    }
    return new commandClass({
      contentPath: formattedImgPath(
        command.contentPath, dim, ftype.fileExt),
      contentClassName: 'BinaryContent',
      binaryData: await CODECS[ftype.fileExt](
        command.binaryData, dim)
    });

  }
}




// WEBPACK FOOTER //
// ./lib/rlink-cms/indexing/images.js